import { createGridSelectionContext } from "@/components/ui/ag-grid-table/createGridSelectionContext";

const { Provider, useStore } = createGridSelectionContext<number>("useRequestLogsSelectionStore");

export const RequestLogsSelectionProvider = Provider;
export const useRequestLogsSelectionStore = useStore;
